/**
 * Site-wide "AED" / "Dhs." -> official UAE Dirham symbol swap.
 * Runs on initial load and re-runs on any DOM subtree added later
 * (cart drawer, quick add modal, predictive search, quantity popovers, etc.)
 * so every current and future price on the storefront picks it up.
 * Does not touch <select>/<option> (native currency pickers must stay plain text)
 * or script/style content.
 */
(function () {
  var SVG_PATH_D =
    'M 381.519 157.184 L 384.5331 160.016 L 384.5331 151.413 C 384.5331 132.451 371.245 117.024 354.911 117.024 L 328.8091 117.027 C 310.551 40.929 248.322 0 155.756 0 C 96.8091 0 89.243 0.002 33.4221 0.002 C 33.4221 0.002 50.178 14.086 50.178 58.437 L 50.178 117.064 L 19.308 117.068 C 13.311 117.068 7.678 114.75 3.014 110.364 L 0 107.53 L 0 116.135 C 0 135.099 13.287 150.526 29.6201 150.526 L 50.178 150.523 L 50.178 183.963 L 19.308 183.967 C 13.3141 183.967 7.6791 181.65 3.014 177.266 L 0 174.433 L 0 183.034 C 0 201.986 13.287 217.405 29.6201 217.405 L 50.178 217.402 L 50.178 278.608 C 50.178 321.712 33.4221 334.433 33.4221 334.433 L 155.756 334.4351 C 251.2321 334.4351 311.469 293.221 329.025 217.366 L 365.223 217.361 C 371.2201 217.361 376.854 219.678 381.519 224.062 L 384.5331 226.895 L 384.5331 218.294 C 384.5331 199.34 371.245 183.921 354.911 183.921 L 333.837 183.924 C 334.1951 178.483 334.386 172.913 334.386 167.199 C 334.386 161.487 334.186 155.92 333.813 150.484 L 365.223 150.48 C 371.2161 150.48 376.8521 152.798 381.519 157.184 Z M 100.3101 16.74 L 151.4481 16.74 C 220.254 16.74 260.1011 47.221 271.9961 117.035 L 100.3101 117.058 L 100.3101 16.74 Z M 151.892 317.728 L 100.3101 317.728 L 100.3101 217.396 L 271.889 217.373 C 260.774 280.559 224.975 315.931 151.892 317.728 Z M 275.806 167.216 C 275.806 172.939 275.681 178.51 275.432 183.932 L 100.3101 183.956 L 100.3101 150.516 L 275.4341 150.492 C 275.678 155.892 275.806 161.458 275.806 167.216 Z';

  var DHS_RE = /Dhs\.\s?/;
  var AED_RE = /\s?\bAED\b/;
  var SKIP_SELECTOR = 'select, option, script, style, noscript, textarea, [contenteditable="true"]';

  function createSymbolEl() {
    var span = document.createElement('span');
    span.className = 'dirham-symbol';
    span.setAttribute('role', 'img');
    span.setAttribute('aria-label', 'AED');
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 384.5331 334.4351');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('fill', 'currentColor');
    path.setAttribute('fill-rule', 'nonzero');
    path.setAttribute('d', SVG_PATH_D);
    svg.appendChild(path);
    span.appendChild(svg);
    return span;
  }

  function shouldSkip(node) {
    var el = node.parentElement;
    return !!(el && el.closest(SKIP_SELECTOR));
  }

  function processTextNode(node) {
    var text = node.nodeValue;
    if (!text || (!DHS_RE.test(text) && !AED_RE.test(text))) return;
    if (shouldSkip(node)) return;

    var frag = document.createDocumentFragment();
    var remaining = text;
    var symbolInserted = false;

    var dhsMatch = remaining.match(DHS_RE);
    if (dhsMatch) {
      var dIdx = dhsMatch.index;
      var dBefore = remaining.slice(0, dIdx);
      if (dBefore) frag.appendChild(document.createTextNode(dBefore));
      frag.appendChild(createSymbolEl());
      remaining = remaining.slice(dIdx + dhsMatch[0].length);
      symbolInserted = true;
    }

    var aedMatch = remaining.match(AED_RE);
    if (aedMatch) {
      var aIdx = aedMatch.index;
      var aBefore = remaining.slice(0, aIdx);
      if (aBefore) frag.appendChild(document.createTextNode(aBefore));
      if (!symbolInserted) {
        frag.appendChild(createSymbolEl());
        symbolInserted = true;
      }
      remaining = remaining.slice(aIdx + aedMatch[0].length);
    }

    if (!symbolInserted) return;

    if (remaining) frag.appendChild(document.createTextNode(remaining));
    node.parentNode.replaceChild(frag, node);
  }

  function sweep(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      processTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || (!DHS_RE.test(n.nodeValue) && !AED_RE.test(n.nodeValue))) {
          return NodeFilter.FILTER_SKIP;
        }
        return shouldSkip(n) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      },
    });

    var nodes = [];
    var current;
    while ((current = walker.nextNode())) {
      nodes.push(current);
    }
    nodes.forEach(processTextNode);
  }

  function init() {
    sweep(document.body);

    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          sweep(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
